






























































import Vue from 'vue';
import { capitalize } from 'lodash';
import { BAlert, BFormCheckbox, BFormTextarea } from 'bootstrap-vue';

import { ZenFormGroup } from 'zenComponents';
import { ModalSize } from '@/components/zen_modal/types';
import { updateObjectField, loadObjectFieldConfig } from '@/utils/crudActions';
import { Alert } from '@/components/global_alerts/types';
import { confirmObjectStatusChange } from '@/components/object_actions/helpers';

import LoadingState from '../loading_state/LoadingState.vue';
import GenericCard from '../GenericCard.vue';
import EditCardCheckbox from './components/EditCardCheckbox.vue';
import EditCardDate from './components/EditCardDate.vue';
import EditCardDropdown from './components/EditCardDropdown.vue';
import EditCardRadio from './components/EditCardRadio.vue';
import EditCardText from './components/EditCardText.vue';
import { IFieldConfig } from '../types';

export default Vue.extend({
  name: 'EditCard',
  components: {
    BAlert,
    BFormCheckbox,
    BFormTextarea,
    GenericCard,
    LoadingState,
    ZenFormGroup,
    EditCardCheckbox,
    EditCardDate,
    EditCardDropdown,
    EditCardRadio,
    EditCardText,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    ids: {
      type: Array,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      components: [] as IFieldConfig[],
      alerts: <Alert[]>[],
      ignoreWarnings: <boolean>false,
      loading: <boolean>false,
      saving: <boolean>false,
      comment: <string>'',
    };
  },
  computed: {
    idParam(): string {
      if (this.bulkEdit) {
        return encodeURIComponent(`bulk:${this.ids.join(',')}`);
      } else {
        return String(this.ids[0]);
      }
    },
    bulkEdit(): boolean {
      return this.ids.length > 1;
    },
    title(): string {
      if (this.components !== undefined && this.components.length > 0) {
        return this.components[0].displayName;
      }
      return '';
    },
  },
  created() {
    const size = this.field === 'description' ? ModalSize.Medium : ModalSize.Small;
    this.$emit('updateConfig', { size });
    this.fetchConfig();
  },
  methods: {
    async fetchConfig() {
      this.loading = true;

      try {
        this.components = await this.loadObjectFieldConfig({
          field: this.field,
          ...(this.bulkEdit ? {} : { id: this.idParam }),
          type: this.type,
        });
      } catch (errors) {
        this.alerts = errors;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (!(await this.confirmBeforeSaving())) {
        return;
      }

      this.saving = true;

      try {
        const updateComponentsArray = Array.from(this.components);
        if (updateComponentsArray.length > 1) {
          updateComponentsArray.sort((a, b) => a.updateOrder - b.updateOrder);
        }

        for (let i = 0; i < updateComponentsArray.length; i++) {
          await this.updateObjectField({
            value: updateComponentsArray[i].value,
            comment: this.comment,
            csrf: document.body.dataset.csrf,
            field: updateComponentsArray[i].attrSlug,
            id: this.idParam,
            ignoreWarnings: this.ignoreWarnings,
            type: this.type,
          });
        }
        window.GGRC.zenModal.$emit('reloadPage');
        this.$emit('close');
      } catch (errors) {
        this.alerts = errors;
      } finally {
        this.saving = false;
      }
    },
    async confirmBeforeSaving(): Promise<boolean> {
      return (
        this.field !== 'status' ||
        (await confirmObjectStatusChange(this.ids.length, this.type, String(this.components[0].value)))
      );
    },
    // Workaround for stubing imported functions
    loadObjectFieldConfig,
    updateObjectField,
    getComponentForType(type: string) {
      return 'EditCard' + capitalize(type);
    },
  },
});
